import { gql } from '@apollo/client';

import { ContactFragment } from '../contact/contact.fragment';

export const BeneficiaryPolicyFragment = gql`
  fragment BeneficiaryPolicyFragment on BeneficiaryPolicy {
    update
    readEscrowMemberships
    createEscrowMemberships
  }
`;

export const BeneficiaryFields = gql`
  ${ContactFragment}
  ${BeneficiaryPolicyFragment}
  fragment BeneficiaryFields on Beneficiary {
    city
    companyName
    companyRegistrationNumber
    companyWebsite
    country
    id
    postalCode
    region
    street
    streetNumber
    contacts {
      ...ContactFragment
    }
    policy {
      ...BeneficiaryPolicyFragment
    }
  }
`;
